import {selectColumn, stringColumn, textAreaColumn} from "../../helpers/commonColumns";
import {softwareProduct_URL} from "../../constants/urlConfig";

export const expiryLicenceActionColumns = () => [
    stringColumn('code', 'Code'),
    selectColumn('softwareProductId', "Software Product", true, softwareProduct_URL, 'code', 'Expiry Action is global and can be applied for any Software Product if this is left empty.'),
    textAreaColumn('description', 'Description')
];